// import streams from "../apis/streams";
import ApiService from "./../services/api-service";
import { FETCH_STREAMS, FETCH_STREAM } from "./types";
import axios from "axios";

const streams = axios.create({
  baseURL: "http://localhost:3001",
});

export const fetchStreams = () => async (dispatch) => {
  const response = await streams.get("/streams");

  dispatch({ type: FETCH_STREAMS, payload: response.data });
};

export const fetchStream = (id) => async (dispatch) => {
  const response = await streams.get(`/streams/${id}`);

  dispatch({ type: FETCH_STREAM, payload: response.data });
};
